// extracted by mini-css-extract-plugin
export default {"modal":"ModifiedFtpModal-module__modal","title":"ModifiedFtpModal-module__title","description":"ModifiedFtpModal-module__description"};